import validator from "validator";

export const extractUuidFromUrl = (value = "") => {
  if (!value) {
    return "";
  }

  return value?.split("/").find((v) => validator.isUUID(v));
};
